import { all, fork } from 'redux-saga/effects';

import * as betaFeaturesSagas from '@/Redux/sagas/BetaFeaturesSaga';
import * as liveShowSaga from '@/Redux/sagas/LiveShowSaga';
import * as myPageSagas from '@/Redux/sagas/MyPageSaga';
import * as postCollectionSagas from '@/Redux/sagas/PostCollectionSaga';
import * as rebateOverrideSagas from '@/Redux/sagas/RebateOverrideSaga';
import * as rebateTncSagas from '@/Redux/sagas/RebateTncSaga';
import * as userGroupsSagas from '@/Redux/sagas/UserGroupsSaga';
import * as accountSagas from '@/Sagas/AccountSaga';
import * as accountsManagementSaga from '@/Sagas/AccountsManagementSaga';
import * as accountInterestSaga from '@/Sagas/AccountsInterestSaga';
import * as affiliateSagas from '@/Sagas/AffiliateSaga';
import * as CensorshipSagas from '@/Sagas/CensorshipSaga';
import * as modalSaga from '@/Sagas/ModalSaga';
import * as postManagementSagas from '@/Sagas/PostManagementSaga';
import * as reportSagas from '@/Sagas/ReportSaga';
import * as reservedProfileIdSagas from '@/Sagas/ReservedProfileIdSaga';
import * as settingSagas from '@/Sagas/SettingSaga';
import * as snsConnectionSagas from '@/Sagas/SnsConnectionSaga';
import * as userRoleSagas from '@/Sagas/UserRoleSaga';
import * as userVerifySagas from '@/Sagas/UserVerifySaga';
import * as vodSagas from '@/Sagas/VodSaga';
import * as whitelistSagas from '@/Sagas/WhitelistDomainSaga';
import * as CrawledPostManagementSagas from '@/Sagas/CrawledPostManagementSaga'

export default function* rootSaga() {
  yield all(
    [
      ...Object.values(accountSagas),
      ...Object.values(accountsManagementSaga),
      ...Object.values(accountInterestSaga),
      ...Object.values(affiliateSagas),
      ...Object.values(betaFeaturesSagas),
      ...Object.values(CensorshipSagas),
      ...Object.values(liveShowSaga),
      ...Object.values(modalSaga),
      ...Object.values(myPageSagas),
      ...Object.values(postCollectionSagas),
      ...Object.values(postManagementSagas),
      ...Object.values(rebateOverrideSagas),
      ...Object.values(rebateTncSagas),
      ...Object.values(reportSagas),
      ...Object.values(reservedProfileIdSagas),
      ...Object.values(settingSagas),
      ...Object.values(snsConnectionSagas),
      ...Object.values(userGroupsSagas),
      ...Object.values(userRoleSagas),
      ...Object.values(userVerifySagas),
      ...Object.values(vodSagas),
      ...Object.values(whitelistSagas),
      ...Object.values(CrawledPostManagementSagas)
    ].map(fork),
  );
}
